import React from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCheck } from "@fortawesome/pro-solid-svg-icons";

import SectionCard from "../SectionCard";
import ActivityRow from "./components/ActivityRow";
import { getActivityLogs } from "./util";

import "./index.scss";

const ActivityLog = ({ appointment, t }) => {
  if (!appointment.pdf_include_activity_logs) return null;

  const rows = getActivityLogs(appointment, t);
  if (!rows.length) return null;

  const title = `${t("cc_activity_log").message || "Activity Log"} (${rows.length})`;

  return (
    <div className="activity-log">
      <SectionCard title={title} icon={<FontAwesomeIcon icon={faUserCheck} />}>
        <div className="activity-log-header">{t("cc_activity").message || "Activity"}</div>
        <div className="activity-log-body">
          {rows.map((row, index) => (
            <ActivityRow key={index} row={row} appointment={appointment} t={t} />
          ))}
        </div>
      </SectionCard>
    </div>
  );
};

export default withTranslation()(ActivityLog);
